var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBenefits3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 36V34C14 28.4772 18.4772 24 24 24C29.5228 24 34 28.4772 34 34V36",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 36V34C2 30.6862 4.6863 28 8 28",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M46 36V34C46 30.6862 43.3138 28 40 28",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24 24C27.3138 24 30 21.3138 30 18C30 14.6863 27.3138 12 24 12C20.6862 12 18 14.6863 18 18C18 21.3138 20.6862 24 24 24Z",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8 28C10.2091 28 12 26.2092 12 24C12 21.7908 10.2091 20 8 20C5.79086 20 4 21.7908 4 24C4 26.2092 5.79086 28 8 28Z",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40 28C42.2092 28 44 26.2092 44 24C44 21.7908 42.2092 20 40 20C37.7908 20 36 21.7908 36 24C36 26.2092 37.7908 28 40 28Z",
    stroke: "#0473FF",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits3);
export default __webpack_public_path__ + "static/media/benefits-3.45bb23df9a801f8c2773ba1f2b163e7a.svg";
export { ForwardRef as ReactComponent };